/**
 * This plugin based on http://www.jacklmoore.com/autosize/
 * */

bq.textareaAutoSize = function (element, options) {
    this.options  = options;
    this.$element = $(element);
};

bq.textareaAutoSize.DEFAULTS = {
    //
};

bq.textareaAutoSize.prototype = {
    init: function () {

        this.$element.on('focus.bq.textareaAutoSize', function () {

            // init autosize() feature
            autosize($(this));

            // remove an event handler after first init
            $(this).off('focus.bq.textareaAutoSize');

        });

    }
};

// TEXTAREA AUTOSIZE DATA PLUGIN DEFINITION
// =======================

var textareaAutoSizeold = $.fn.textareaAutoSize;

$.fn.textareaAutoSize = function (option, _relatedTarget) {
    return this.each(function () {
        var $this   = $(this);
        var data    = $this.data('bq.textareaAutoSize');
        var options = $.extend({}, bq.textareaAutoSize.DEFAULTS, $this.data(), typeof(option) === 'object' && option);

        if (!data) {
            $this.data('bq.textareaAutoSize', (data = new bq.textareaAutoSize(this, options)));
        }
        data.init();
    });
};

$.fn.textareaAutoSize.Constructor = bq.textareaAutoSize;

// TEXTAREA AUTOSIZE DATA NO CONFLICT
// =================

$.fn.textareaAutoSize.noConflict = function () {
    $.fn.textareaAutoSize = textareaAutoSizeold;
    return this;
};

// TEXTAREA AUTOSIZE DATA DATA-API
// ==============

bq.textareaAutoSizeInit = function () {
    $('textarea:not(.disable-autosize)').each(function () {
        var el = $(this);
        if (el.data('bq.textareaAutoSize')) {
            return;
        }
        el.textareaAutoSize(el.data());
    });
};

bq.init.push(bq.textareaAutoSizeInit);
